/**
 * Sync Shopify contact / quote forms to HCN leads API.
 * Does NOT block native Shopify submit (keeps storefront CAPTCHA working).
 * Uses keepalive + sessionStorage retry so leads still send after page navigation.
 */
(function () {
  var config = window.HCN_LEAD_CONFIG;
  if (!config || !config.enabled || !config.apiUrl || !config.apiKey) return;

  var STORAGE_KEY = 'hcn_lead_pending_v1';

  function fieldValue(form, names) {
    for (var i = 0; i < names.length; i++) {
      var el = form.querySelector('[name="' + names[i] + '"]');
      if (!el) continue;
      var value = String(el.value || '').trim();
      if (value) return value;
    }
    return '';
  }

  function isLeadForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.getAttribute('data-hcn-lead') === 'skip') return false;
    if (form.querySelector('input[name="contact[tags]"]')) return false;
    return !!(
      form.querySelector('[name="contact[message]"]') ||
      form.querySelector('[name="contact[body]"]') ||
      form.querySelector('[name="contact[product]"]') ||
      form.querySelector('[name="contact[first_name]"]') ||
      form.getAttribute('data-hcn-lead')
    );
  }

  function buildPayload(form) {
    var source = form.getAttribute('data-hcn-lead') || 'contact';
    var first = fieldValue(form, ['contact[first_name]']);
    var last = fieldValue(form, ['contact[last_name]']);
    var fullName = fieldValue(form, ['contact[name]']) || [first, last].filter(Boolean).join(' ').trim();
    var productName = fieldValue(form, [
      'contact[product_name]',
      'contact[product]'
    ]);
    var message = fieldValue(form, ['contact[message]', 'contact[body]']);

    var extras = [];
    var map = [
      ['Country', 'contact[country]'],
      ['Inquiry Type', 'contact[inquiry_type]'],
      ['Variant', 'contact[variant]'],
      ['SKU', 'contact[sku]']
    ];

    for (var i = 0; i < map.length; i++) {
      var val = fieldValue(form, [map[i][1]]);
      if (val) extras.push(map[i][0] + ': ' + val);
    }

    if (extras.length) {
      message = (message ? message + '\n\n' : '') + extras.join('\n');
    }

    return {
      site_domain: config.siteDomain || window.location.hostname,
      site_name: config.siteName || document.title,
      name: fullName,
      phone: fieldValue(form, ['contact[phone]']),
      email: fieldValue(form, ['contact[email]']),
      product_name: productName,
      source: source,
      message: message,
      page_url: window.location.href,
      external_id: 'shopify-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10)
    };
  }

  function readPending() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function writePending(payload) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  function clearPending(externalId) {
    try {
      var pending = readPending();
      if (!pending || !externalId || pending.external_id === externalId) {
        sessionStorage.removeItem(STORAGE_KEY);
      }
    } catch (e) {}
  }

  function sendToHcn(payload) {
    return fetch(config.apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-HCN-Lead-Key': config.apiKey
      },
      body: JSON.stringify(payload),
      keepalive: true,
      mode: 'cors',
      credentials: 'omit'
    }).then(function (res) {
      if (!res.ok) {
        return res.text().then(function (body) {
          throw new Error(body || 'Lead API failed (' + res.status + ')');
        });
      }
      return res;
    });
  }

  function flushPending() {
    var pending = readPending();
    if (!pending || !pending.external_id) return;

    sendToHcn(pending)
      .then(function () {
        clearPending(pending.external_id);
      })
      .catch(function (err) {
        console.error('[HCN Lead API] retry failed', err);
      });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!isLeadForm(form)) return;

      var payload = buildPayload(form);
      if (!payload.email && !payload.phone && !payload.message) return;

      // Persist first so a CAPTCHA delay / page reload can still deliver the lead.
      writePending(payload);

      sendToHcn(payload)
        .then(function () {
          clearPending(payload.external_id);
        })
        .catch(function (err) {
          console.error('[HCN Lead API]', err);
          // Keep sessionStorage pending for flushPending() on the next page.
        });
    },
    true
  );

  // Retry any lead that was interrupted by navigation / CAPTCHA timing.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', flushPending);
  } else {
    flushPending();
  }
})();
